import React, { useState, useEffect } from 'react';
import { getApi } from '../services/apiServices';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

function RefundPolicy() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const [policyData, setPolicyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Language mapping function to convert app language codes to API language codes
  const getApiLanguageCode = (appLanguage) => {
    const languageMap = {
      'ar': 'ar',     // Arabic
      'da': 'da',     // Danish
      'de': 'de',     // German
      'en': 'en',     // English
      'es': 'es',     // Spanish
      'fr': 'fr',     // French
      'he': 'he',     // Hebrew
      'it': 'it',     // Italian
      'ja': 'ja',     // Japanese
      'ko': 'ko',     // Korean
      'nl': 'nl',     // Dutch
      'no': 'no',     // Norwegian
      'pl': 'pl',     // Polish
      'pt': 'pt',     // Portuguese
      'ru': 'ru',     // Russian
      'sv': 'sv',     // Swedish
      'tr': 'tr',     // Turkish
      'zh': 'zh_CN'   // Chinese (Simplified)
    };
    return languageMap[appLanguage] || 'en'; // Default to English if not found
  };

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        setLoading(true);
        const apiLanguage = getApiLanguageCode(currentLanguage);
        const response = await getApi(`/api/refund-policy?lang=${apiLanguage}`);
        if (response?.status && Array.isArray(response?.data)) {
          setPolicyData(response.data);
        } else {
          setError('Failed to fetch refund policy.');
        }
      } catch (err) {
        setError('Failed to fetch refund policy.');
      } finally {
        setLoading(false);
      }
    };
    fetchPolicy();
  }, [currentLanguage]);

  if (loading) return (
    <div className="loader-overlay">
      <span className="loader"></span>
    </div>
  );
  if (error) return <div>{error}</div>;

  // Group by section, then by sub_section
  const grouped = policyData.reduce((acc, item) => {
    if (!acc[item.section]) acc[item.section] = {};
    const sub = item.sub_section || '__no_sub__';
    if (!acc[item.section][sub]) acc[item.section][sub] = [];
    acc[item.section][sub].push(item.content);
    return acc;
  }, {});

  return (
    <section className="faq terms-nd-condition">
      <div className='container'>
        <h1 className='main-heading'>{t('refundPolicy.title')}</h1>
        {Object.entries(grouped).map(([section, subs]) => (
          <div key={section} >
            <h2 className='inner-heading'>{section}</h2>
            {Object.entries(subs).map(([sub, contents]) => (
              <div key={sub} className='refund-div'>
                {sub !== '__no_sub__' && <h3>{sub}</h3>}
                <ul className='terms-list'>
                  {contents.map((content, idx) => (
                    <li key={idx} style={{ whiteSpace: 'pre-line' }}>{content}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}

export default RefundPolicy;
